import { useGamepadSession } from "../../unboared-com";

import Scenario from "./config/Scenario";
import CodenamesStyles from './CodenamesStyles'

const GamepadApp = () => {
    const scenario = useGamepadSession(state => state.scenario);

    return (
        <CodenamesStyles>
            <div className="gamepad">
                {Scenario[scenario].gamepad}
            </div>
        </CodenamesStyles>
    )
}

export default GamepadApp;
